import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../services/api-service/api-service.service';
import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';
import { ContextFactory } from '@shared/factories/context/context.factory';

@Injectable({
  providedIn: 'root'
})
export class EditDocumentOffice365Factory {
  editDocument:any = {}
  constructor(private apiService: ApiServiceService,
    private context: ContextFactory,
  ) { }

  addMessageEventListener() {
    window.addEventListener("message", (event: any) => {
      if (this.originIsAllowed(event.origin, this.editDocument.allowedOrigins)) {
        if (event.data && event.data.message == 'get-context365') {
          console.log(this.editDocument.documentToEdit.conceptObjectId)
          let data = {
            conceptObjectId: this.editDocument.documentToEdit.conceptObjectId,
            documentObjectId: this.editDocument.documentToEdit.documentObjectId,
            jwtToken: this.context.jwtToken
          };
          event.source.postMessage({
            message: 'context',
            data: data
          }, event.origin,);
        }
      }
    });
  }

  originIsAllowed(origin: any, allowedOrigins: string) {
    if (allowedOrigins) {
      let origins = allowedOrigins.split(';');
      for (let i = 0; i < origins.length; i++) {
        if (origin === origins[i]) {
          return true;
        }
      }
    }
    return false;
  }

  recieveAndProcessDocument(documentSelected:any){
    this.editDocument.documentToEdit = documentSelected;
    this.openDocument()
  }

  openDocument(){
    this.apiService.get('utils/office365', 'login-url')
      .then((data:any)=>{
        this.editDocument.loginUrl = data.loginUrl;
        this.editDocument.idOperation = data.idOperation
        this.editDocument.token = data.token
        this.editDocument.allowedOrigins = data.allowedOrigins
        this.initAuth()
      },(errorData:any)=>{

      })
  }

  initAuth(){
    let win:any = window.open(
      this.editDocument.loginUrl,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400'
    );
    let timer = setInterval(async ()=>{
      if (win.closed) {
        clearInterval(timer);
        this.getEditUrl()
      }
    }, 1000);
  }


  getEditUrl(){
    let tokenObject:any = {
      idOperation: this.editDocument.idOperation,
      token: this.editDocument.token
    }
    let expandUrl: string = this.editDocument.documentToEdit.documentObjectId? `?documentObjectId=${this.editDocument.documentToEdit.documentObjectId}`:`?reportDocumentId=${this.editDocument.documentToEdit.reportDocumentId}`;
    this.apiService.add(`utils/office365/upload/${expandUrl}`, tokenObject)
      .then((data: any) => {
        if (this.editDocument.documentToEdit.documentObjectId) {
          this.addMessageEventListener();
        }
        window.open(data.documentEditUrl);
      });
  }

}
